import { Box, Grid, Stepper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "../Analytics.css";
import Chart from "react-apexcharts";
import { CheckCircle, AccountCircle, WatchLater, EventAvailable } from "@mui/icons-material";
import { BatchTrackerSkeleton, SkeletonLoader1, SkeletonLoader2 } from "../../reusables/SkeletonLoader/SkeletonLoader";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import CCService from "../../../services/httpServiceWithoutSuperAdmin";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import DescriptionIcon from "@mui/icons-material/Description";
import ReactApexChart from "react-apexcharts";
import BatchWiseAnalytics from "./BatchWiseAnalytics";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { createRoot } from "react-dom/client";
import { AgChartsReact } from "ag-charts-react";
// import { Bar } from 'react-chartjs-2';

function BatchProgressTracker(props) {
  const service = new CCService();
  const date = new Date();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation()
  const { college_id, college_name, program_id, program_name,  } = props;
  const [batchProgressTrackerSkeletonLoader, setBatchProgressTrackerSkeletonLoader] = useState(false);
  const activated_students = props.activated_students || location.state.activated_students
  const non_activated_students = props.non_activated_students || location.state.non_activated_students
  const [progressTracker, setProgressTracker] = useState({
    DiagnosticInterview: { state: "done", color: "#45A834" },
    SIPSuccess: { state: "done", color: "#45A834" },
    ResumeDiscussion: { state: "Ongoing", color: "#E88F09" },
    MockInterview: { state: "planned", color: "#7F7F7F" },
  });

  const [testOnApp, setTestOnApp] = useState([
    { description: "Students attempted tests", value: 0 },
    { description: "Total tests attempted by the batch", value: 0 },
    { description: "Quantitative Ability Tests", value: 0 },
    { description: "Verbal Ability tests", value: 0 },
    { description: "Logical Ability Tests", value: 0 },
    { description: "Role Preparedness Tests", value: 0 },
  ]);

  // const [batchProgressTracker, setBatchProgressTracker] = useState([])
  const [testNumbers, setTestNumbers] = useState({});
  const [dayWisePromptness, setDayWisePromptness] = useState({});
  const [active_time, setActive_Time] = useState({});
  const [aptitude_test, setAptitude_Test] = useState({});
  const [tests_specialization_wise, setTests_Specialization_Wise] = useState({});
  const [batchProgressTracker, setBatchProgressTracker] = useState([]);
  const [batchProgressTrackerSEQ, setBatchProgressTrackerSEQ] = useState([]);
  console.log("batchProgressTracker", batchProgressTracker, batchProgressTrackerSEQ);

  const Line = () => {
    return (
      <svg width="235" height="7" viewBox="0 0 235 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M235 3.73438L229.996 0.854691L230.004 6.62819L235 3.73438ZM0.000706449 4.56641L2.02657 4.56354L2.02516 3.56354L-0.000706449 3.56641L0.000706449 4.56641ZM6.07829 4.55782L10.13 4.55209L10.1286 3.5521L6.07688 3.55782L6.07829 4.55782ZM14.1817 4.54637L18.2335 4.54064L18.2321 3.54065L14.1803 3.54637L14.1817 4.54637ZM22.2852 4.53492L26.3369 4.5292L26.3355 3.5292L22.2838 3.53492L22.2852 4.53492ZM30.3886 4.52347L34.4404 4.51775L34.4389 3.51775L30.3872 3.52347L30.3886 4.52347ZM38.4921 4.51202L42.5438 4.5063L42.5424 3.5063L38.4907 3.51202L38.4921 4.51202ZM46.5955 4.50057L50.6473 4.49485L50.6458 3.49485L46.5941 3.50057L46.5955 4.50057ZM54.699 4.48912L58.7507 4.4834L58.7493 3.4834L54.6976 3.48912L54.699 4.48912ZM62.8024 4.47767L66.8541 4.47195L66.8527 3.47195L62.801 3.47767L62.8024 4.47767ZM70.9059 4.46622L74.9576 4.4605L74.9562 3.4605L70.9045 3.46622L70.9059 4.46622ZM79.0093 4.45477L83.061 4.44905L83.0596 3.44905L79.0079 3.45478L79.0093 4.45477ZM87.1128 4.44333L91.1645 4.4376L91.1631 3.4376L87.1113 3.44333L87.1128 4.44333ZM95.2162 4.43188L99.2679 4.42615L99.2665 3.42615L95.2148 3.43188L95.2162 4.43188ZM103.32 4.42043L107.371 4.4147L107.37 3.4147L103.318 3.42043L103.32 4.42043ZM111.423 4.40898L115.475 4.40325L115.473 3.40325L111.422 3.40898L111.423 4.40898ZM119.527 4.39753L123.578 4.3918L123.577 3.3918L119.525 3.39753L119.527 4.39753ZM127.63 4.38608L131.682 4.38035L131.68 3.38035L127.629 3.38608L127.63 4.38608ZM135.733 4.37463L139.785 4.3689L139.784 3.36891L135.732 3.37463L135.733 4.37463ZM143.837 4.36318L147.889 4.35746L147.887 3.35746L143.835 3.36318L143.837 4.36318ZM151.94 4.35173L155.992 4.34601L155.991 3.34601L151.939 3.35173L151.94 4.35173ZM160.044 4.34028L164.096 4.33456L164.094 3.33456L160.042 3.34028L160.044 4.34028ZM168.147 4.32883L172.199 4.32311L172.198 3.32311L168.146 3.32883L168.147 4.32883ZM176.251 4.31738L180.302 4.31166L180.301 3.31166L176.249 3.31738L176.251 4.31738ZM184.354 4.30593L188.406 4.30021L188.404 3.30021L184.353 3.30593L184.354 4.30593ZM192.458 4.29448L196.509 4.28876L196.508 3.28876L192.456 3.29448L192.458 4.29448ZM200.561 4.28303L204.613 4.27731L204.611 3.27731L200.56 3.28304L200.561 4.28303ZM208.664 4.27158L212.716 4.26586L212.715 3.26586L208.663 3.27159L208.664 4.27158ZM216.768 4.26014L220.82 4.25441L220.818 3.25441L216.766 3.26014L216.768 4.26014ZM224.871 4.24869L228.923 4.24296L228.922 3.24296L224.87 3.24869L224.871 4.24869Z"
          fill="#1C8EA8"
        />
      </svg>
    );
  };

  useEffect(() => {
    const handleEffect = async () => {
      setBatchProgressTrackerSkeletonLoader(true);
      if (Cookies.get("token") === null || Cookies.get("token") === undefined) {
        navigate("/");
      }
      // let batchProgressTracker = await batchProgressTrackerDataGetter();
      // console.log("bhoomika", { batchProgressTracker })
      console.log("testNumbers", testNumbers);
      console.log("dayWisePromptness", dayWisePromptness);
      console.log("active_time", active_time);
      console.log("aptitude test", aptitude_test);
      // console.log("tests_specialization_wise", tests_specialization_wise);
      let batchProgressTrackersDetails = await batchProgressTrackerDataGetter();
      let SEQDataGetter = await batchProgressTrackerSEQGetter();
      console.log("SEQDataGetter", SEQDataGetter);
      setBatchProgressTrackerSEQ(SEQDataGetter);
      const temp_test_numbers = batchProgressTrackersDetails?.test_numbers ? JSON.parse(batchProgressTrackersDetails?.test_numbers) : {};
      // console.log("test numbers", temp_test_numbers);
      setTestNumbers(temp_test_numbers);
      // setbatchProgressTrackersDetails(batchProgressTrackersDetails)
      const updatedTestOnApp = testOnApp.map((item) => {
        switch (item.description) {
          case "Students attempted tests":
            item.value = temp_test_numbers.total_student;
            break;
          case "Logical Ability Tests":
            item.value = temp_test_numbers.logical_ability_tests;
            break;
          case "Quantitative Ability Tests":
            item.value = temp_test_numbers.quantitative_ability_tests;
            break;
          case "Role Preparedness Tests":
            item.value = temp_test_numbers.role_Preparedness_tests;
            break;
          case "Total tests attempted by the batch":
            item.value = temp_test_numbers.total_tests_attempted;
            break;
          case "Verbal Ability tests":
            item.value = temp_test_numbers.verbal_ability_tests;
            break;
          default:
            break;
        }
        return item;
      });

      const temp_day_wise_promptness = batchProgressTrackersDetails.day_wise_promptness ? JSON.parse(batchProgressTrackersDetails?.day_wise_promptness) : null;
      const again_temp_day_wise = temp_day_wise_promptness ? JSON.parse(temp_day_wise_promptness) : {};
      console.log("temp day wise", temp_day_wise_promptness);

      const temp_tests_specialization_wise = batchProgressTrackersDetails?.tests_specialization_wise;
      const modifiedJsonString = temp_tests_specialization_wise?.replace(/NaN/g, "0");
      console.log("temp_tests_specialization_wise", temp_tests_specialization_wise, modifiedJsonString);
      const again_temp_tests_specialization_wise = modifiedJsonString ? JSON.parse(modifiedJsonString) : [];
      // console.log("filtering of tests", again_temp_tests_specialization_wise.filter((item) => {}));
      const filteredTests_Specialization_Wise = Object.keys(again_temp_tests_specialization_wise)
        .filter((key) => again_temp_tests_specialization_wise[key] !== 0)
        .reduce((result, key) => {
          result[key] = again_temp_tests_specialization_wise[key];
          return result;
        }, {});

      // Use filteredTests_Specialization_Wise as needed
      console.log("filteredTests_Specialization_Wise", filteredTests_Specialization_Wise);

      // If you want to set the filtered object in state
      setTests_Specialization_Wise(filteredTests_Specialization_Wise);
      // setTests_Specialization_Wise(again_temp_tests_specialization_wise)

      setRolePreferenceSeries([{ data: Object.values(filteredTests_Specialization_Wise).map(DecimalToPercentage) }]);
      setRolePreferenceOptions((prev) => {
        return {
          ...prev,
          xaxis: {
            categories: Object.keys(filteredTests_Specialization_Wise),
          },
        };
      });

      // setSEQSeries({ data: SEQDataGetter?.map(({ seq }) => ({  seq }));
      // setSEQSeries({ data: SEQDataGetter?.map(({ seq }) => ({ seq })) });

      // let data1 = SEQDataGetter.filter((item) => item.seq <= 0.1);
      // let data2 = SEQDataGetter.filter((item) => item.seq <= 0.2 && item.seq >= 0.1);
      // let data3 = SEQDataGetter.filter((item) => item.seq <= 0.3 && item.seq >= 0.2);
      // let data4 = SEQDataGetter.filter((item) => item.seq <= 0.4 && item.seq <= 0.3);
      // let data5 = SEQDataGetter.filter((item) => item.seq <= 0.5 && item.seq <= 0.4);
      // let data6 = SEQDataGetter.filter((item) => item.seq <= 0.6 && item.seq <= 0.5);
      // let data7 = SEQDataGetter.filter((item) => item.seq <= 0.5 && item.seq <= 0.6);
      // let data8 = SEQDataGetter.filter((item) => item.seq <= 0.8 && item.seq <= 0.5);
      // let data9 = SEQDataGetter.filter((item) => item.seq <= 0.9 && item.seq <= 0.8);
      // let data10 = SEQDataGetter.filter((item) => item.seq <= 1 && item.seq >= 0.9);

      // setOptions((prev) => {
      //   return {
      //     ...prev,
      //     data: [
      //       { value: data1.length, bin: 0.1 },
      //       { value: data2.length, bin: 0.2 },
      //       { value: data3.length, bin: 0.3 },
      //       { value: data4.length, bin: 0.4 },
      //       { value: data5.length, bin: 0.5 },
      //       { value: data6.length, bin: 0.6 },
      //       { value: data7.length, bin: 0.5 },
      //       { value: data8.length, bin: 0.8 },
      //       { value: data9.length, bin: 0.9 },
      //       { value: data10.length, bin: 1 },
      //     ],
      //   };
      // });

      setOptions((prev) => {
        const modifiedData = SEQDataGetter?.map((batch) => {
          const bins = JSON.parse(batch.bins);
          const counts = JSON.parse(batch.count);

          const numBins = bins.length;
          const numCounts = counts.length;

          if (numBins > numCounts) {
            bins.pop();
          }

          const dataInBins = bins.map((bin, index) => ({
            bin: bin * 100,
            value: counts[index],
          }));

          return dataInBins;
        }).flat();

        console.log("modifiedData", modifiedData);

        return {
          ...prev,
          data: modifiedData,
        };
      });

      console.log("options", options);

      setChartData({
        labels: ["F", "G", "H", "I", "J"], // New labels
        datasets: [
          {
            ...chartData.datasets[0],
            data: SEQDataGetter?.map((item) => item?.seq), // New data
          },
        ],
      });
      // setSEQOptions((prev) => {
      //   return {
      //     ...prev,
      //     xaxis: {
      //       categories: Object.keys(filteredTests_Specialization_Wise),
      //     },
      //   };
      // });

      const temp_aptitude_tests = batchProgressTrackersDetails?.aptitude_tests ? JSON.parse(batchProgressTrackersDetails?.aptitude_tests) : {};
      const again_temp_aptitude_tests = temp_aptitude_tests ? JSON.parse(temp_aptitude_tests) : {};

      const temp_active_time = batchProgressTrackersDetails?.active_time ? JSON.parse(batchProgressTrackersDetails?.active_time) : {};
      const again_temp_active_time = temp_active_time ? JSON.parse(temp_active_time) : {};

      setDayWisePromptness(again_temp_day_wise);
      setAptitude_Test(again_temp_aptitude_tests);
      const sortedTimeRanges = Object.keys(again_temp_active_time).sort((a, b) => {
        const order = ["12am-6am", "6am-12pm", "12pm-6pm", "6pm-12am"];
        return order.indexOf(a) - order.indexOf(b);
      });

      // 3. Create a new object with the sorted time ranges
      const sortedActiveTimeData = {};
      sortedTimeRanges.forEach((range) => {
        sortedActiveTimeData[range] = again_temp_active_time[range];
      });
      setActive_Time(sortedActiveTimeData);
      setTestOnApp(updatedTestOnApp);
      setBatchProgressTracker(batchProgressTrackersDetails);

      setBatchProgressTrackerSkeletonLoader(false);
    };
    handleEffect();
  }, [program_id]);
  console.log("day wise promptness", { dayWisePromptness }, { active_time }, { aptitude_test }, { tests_specialization_wise });

  function DecimalToPercentage(data) {
    const percentage = data * 100;
    return Math.round(percentage);
  }

  const dayWisePromptenessOptions = {
    chart: {
      id: "apexchart-example",
      borderRadius: "20px",
      toolbar: {
        show: false
      }
    },
    xaxis: {
      axisBorder: { show: false },
      categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    yaxis: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val;
      },
      offsetY: -5,
      style: {
        fontSize: "12px",
        colors: ["#1f8fa9"],
      },
    },
    grid: { show: false },
    colors: ["rgba(56, 193, 223, 0.5)"],
    barWidth: 10,
    legend: {
      show: false,
      position: "top",
      showForSingleSeries: true,
      fontSize: "14px",
      barWidth: 10,
      // borderRadius:"20px"
      // customLegendItems: ["Role Preference"],
    },
    plotOptions: {
      bar: {
        borderRadius: 10, // Adjust the border radius to your preference
        barWidth: 10,
        columnWidth: "30%",
      },
    },
  };

  const [rolePreferenceOptions, setRolePreferenceOptions] = useState({
    chart: {
      id: "apexchart-example",
      toolbar: {
        show: false
      }
    },
    xaxis: {
      categories: [],
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val;
      },
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#1f8fa9"],
      },
    },
    yaxis: {
      show: true,
      title: {
        text: "Average score",
        style: {
          fontSize: "12px",
          fontWeight: 600,
        },
      },
    },
    colors: ["rgba(56, 193, 223, 0.5)"],
    legend: {
      show: true,
      position: "top",
      showForSingleSeries: true,
      fontSize: "14px",
      customLegendItems: ["Batch Score"],
    },
    plotOptions: {
      bar: {
        columnWidth: "25%",
        dataLabels: {
          position: "top",
          offsetY: 30000,
        }, // Adjust the percentage to change the bar width
      },
    },
  });

  const [rolePreferenceSeries, setRolePreferenceSeries] = useState([
    {
      data: [],
    },
  ]);

  // const [SEQSeries, setSEQSeries] = useState({
  //   title: {
  //     text: "Prize money distribution",
  //   },
  //   subtitle: {
  //     text: "Total winnings by participant age",
  //   },
  //   data: [],
  //   series: [
  //     {
  //       type: "histogram",
  //       xKey: "seq",
  //       xName: "Participant Age",
  //       yKey: "winnings",
  //       yName: "Winnings",
  //       aggregation: "sum",
  //     },
  //   ],
  //   axes: [
  //     {
  //       type: "number",
  //       position: "bottom",
  //       title: { text: "Age band (years)" },
  //       tick: { interval: 2 },
  //     },
  //     {
  //       type: "number",
  //       position: "left",
  //       title: { text: "Total winnings (USD)" },options
  //     },
  //   ],
  // });

  const [options, setOptions] = useState({
    data: [],

    series: [
      {
        type: "histogram",
        xKey: "bin",
        // xName: "Casual",
        yKey: "value",

        fill: "#41B8D5",
        stroke: "#fff",
      },
    ],
    areaPlot: true,
    axes: [
      {
        type: "number",
        position: "bottom",
        // title: { text: "casual" },
        min: 0,
      },
      {
        type: "number",
        position: "left",
        title: { text: "No. of Students" },
      },
    ],
  });

  const [chartData, setChartData] = useState({
    labels: ["A", "B", "C", "D", "E"],
    datasets: [
      {
        label: "Histogram",
        data: [12, 19, 3, 5, 2],
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  });

  const dayWisePromptenessSeries = [
    {
      data: [dayWisePromptness.mon ? DecimalToPercentage(dayWisePromptness.mon) : 0, dayWisePromptness.tue ? DecimalToPercentage(dayWisePromptness.tue) : 0, dayWisePromptness.wed ? DecimalToPercentage(dayWisePromptness.wed) : 0, dayWisePromptness.thu ? DecimalToPercentage(dayWisePromptness.thu) : 0, dayWisePromptness.fri ? DecimalToPercentage(dayWisePromptness.fri) : 0, dayWisePromptness.sat ? DecimalToPercentage(dayWisePromptness.sat) : 0, dayWisePromptness.sun ? DecimalToPercentage(dayWisePromptness.sun) : 0],
    },
  ];

  const overAllAptitudeTestData = {
    series: [
      {
        data: [aptitude_test?.["overall"]?.toFixed(4) * 100],
      },
    ],

    options: {
      chart: {
        borderRadius: "20px",
        type: "bar",
        height: 200,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          horizontal: true,
          //   height:100
        },
      },

      xaxis: {
        axisBorder: { show: false },
        categories: ["OverAll"],
        show: false,
        max: 100,
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        // offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#1f8fa9"],
        },
      },
      grid: { show: false },
      colors: ["rgba(56, 193, 223, 0.5)"],

      barWidth: 10,
      legend: {
        show: false,
        position: "top",
        showForSingleSeries: true,
        fontSize: "14px",
        barWidth: 10,
        // borderRadius:"20px"
        // customLegendItems: ["Role Preference"],
      },
    },
  };

  const quantitativeData = {
    series: [
      {
        data: [DecimalToPercentage(aptitude_test?.["4"]), DecimalToPercentage(aptitude_test?.["3"]), DecimalToPercentage(aptitude_test?.["2"])],
      },
    ],
    colors: ["rgba(56, 193, 223, 0.5)"],

    options: {
      chart: {
        borderRadius: "20px",
        type: "bar",
        height: 200,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          horizontal: true,

          //   height:100
        },
      },
      xaxis: {
        axisBorder: { show: false },
        show: false,
        categories: ["Quantitative", "Verbal", "Logical"],
        max: 100,
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val;
        },
        // offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#1f8fa9"],
        },
      },
      grid: { show: false },
      colors: ["rgba(56, 193, 223, 0.5)"],
      barWidth: 10,
      legend: {
        show: false,
        position: "top",
        showForSingleSeries: true,
        fontSize: "14px",
        barWidth: 10,
        // borderRadius:"20px"
        // customLegendItems: ["Role Preference"],
      },
    },
  };
  const logicalData = {
    series: [
      {
        data: [DecimalToPercentage(aptitude_test?.["2"])],
      },
    ],

    options: {
      chart: {
        borderRadius: "20px",
        type: "bar",
        height: 200,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          horizontal: true,
          //   height:100
        },
      },
      xaxis: {
        axisBorder: { show: false },
        categories: ["Logical"],
      },

      grid: { show: false },
      colors: ["rgba(56, 193, 223, 0.5)"],
      barWidth: 10,
      legend: {
        show: false,
        position: "top",
        showForSingleSeries: true,
        fontSize: "14px",
        barWidth: 10,
        // borderRadius:"20px"
        // customLegendItems: ["Role Preference"],
      },
    },
  };

  const verbalData = {
    series: [
      {
        data: [DecimalToPercentage(aptitude_test?.["3"])],
      },
    ],

    options: {
      chart: {
        borderRadius: "20px",
        type: "bar",
        height: 200,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          horizontal: true,
          //   height:100
        },
      },
      xaxis: {
        axisBorder: { show: false },
        categories: ["Verbal"],
      },

      grid: { show: false },
      colors: ["rgba(56, 193, 223, 0.5)"],
      barWidth: 10,
      legend: {
        show: false,
        position: "top",
        showForSingleSeries: true,
        fontSize: "14px",
        barWidth: 10,
        // borderRadius:"20px"
        // customLegendItems: ["Role Preference"],
      },
    },
  };

  const batchProgressTrackerDataGetter = async () => {
    try {
      const res = await service.get(`/analytics/user/progressTracker?user_group_id=${program_id}`);
      console.log("analytics data response:", res.data);
      return res.data[0];
    } catch (err) {
      console.log(err);
    }
  };
  const batchProgressTrackerSEQGetter = async () => {
    try {
      const res = await service.get(`/analysis/batchHistogram?batch_id=${program_id}`);
      console.log("getEngagementQuotient data response:", res.batchHistogramData);
      return res.batchHistogramData;
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Box className="main-container">
      {batchProgressTrackerSkeletonLoader && batchProgressTracker.length !== 0 ? (
        <BatchTrackerSkeleton />
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem", marginTop: "1.5rem" }}>
            <Box sx={{ height: "2px", width: "100%", background: "#E88F09" }}></Box>
            <Typography variant="h1" sx={{ color: "#E88F09", textAlign: "center", fontWeight: "600", width: "1000px" , letterSpacing: "2.5px"}}>
              Batch Progress Tracker
            </Typography>
            <Box sx={{ height: "2px", width: "100%", background: "#E88F09" }}></Box>
          </Box>
          <Box borderRadius={5} sx={{ border: "1px solid rgba(255, 165, 0, 0.3)", padding: "1rem" }}>
            <Typography variant="h2" style={{ fontWeight: "bold", textAlign: "center" }}>
              {college_name} | {program_name}{" "}| {activated_students + non_activated_students}  students
            </Typography>
            <Typography variant="h6" sx={{ color: "#FF3131", textAlign: "center", marginTop: "1rem" }}>
              DISCLAIMER
            </Typography>
            <Typography variant="body1" class="body1font2" style={{ textAlign: "center" }}>
              All information in these reports are provided “as is”, with no guarantee of completeness, accuracy, timeliness or of the results obtained from the use of this information, and without warranty of any kind. All quantifications or comments in all reports have no bearing on actual performance of any individual or group. These scores may vary from 1 session to another. The company will not be liable to you or anyone else for any decision made or action taken in reliance on the information given by these reports or for any consequential, special or similar damages, even if advised of the possibility of such damages.
            </Typography>
          </Box>
          <Box borderRadius={5} sx={{ border: "1px solid rgba(255, 165, 0, 0.3)", padding: "1rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Typography variant="h4" sx={{}}>
              Assessment Tests Overview
            </Typography>
            <Box style={{ float: "right" }}>
              {Object.keys(testNumbers).length === 0 ? (
                <>
                  <Typography class="label-grey-text textTagsHere">No Data Available </Typography>
                </>
              ) : (
                <>
                  <Box sx={{ display: "flex", gap: "20px" }}>
                    <Box sx={{ width: "40%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", borderRight: "2px solid #41B8D5" }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <img src="https://ccicons.s3.amazonaws.com/analytics/studentssvg.svg" style={{ width: "70px", height: "70px" }} />
                        <Typography sx={{ fontSize: "32px", color: "#41B8D5" }}>{testOnApp[0].value}</Typography>
                      </Box>
                      <Typography sx={{ fontSize: "16px", textAlign: "center" }}>{testOnApp[0].description}</Typography>
                    </Box>

                    <Box sx={{ width: "60%", display: "flex", flexDirection: "column", gap: "10px" }}>
                      <Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <img src="https://ccicons.s3.amazonaws.com/analytics/testssvg.svg" style={{ width: "50px", height: "50px" }} />
                          <Typography sx={{ fontSize: "32px", color: "#41B8D5" }}>{testOnApp[1].value}</Typography>
                          <Typography sx={{ fontSize: "16px", textAlign: "center", marginLeft: "10px" }}>{testOnApp[1].description}</Typography>
                        </Box>
                      </Box>

                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ display: "flex", alignItems: "center", width: "100%", paddingLeft: "10%", gap: "2px" }}>
                          <img src="https://ccicons.s3.amazonaws.com/analytics/tickMarksvg.svg" style={{ width: "30px", height: "30px" }} />
                          <Typography sx={{ fontSize: "22px", color: "#41B8D5" }}>{testOnApp[2].value}</Typography>
                          <Typography sx={{ fontSize: "14px", textAlign: "center", marginLeft: "10px" }}>{testOnApp[2].description}</Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", width: "100%", paddingLeft: "10%", gap: "2px" }}>
                          <img src="https://ccicons.s3.amazonaws.com/analytics/tickMarksvg.svg" style={{ width: "30px", height: "30px" }} />
                          <Typography sx={{ fontSize: "22px", color: "#41B8D5" }}>{testOnApp[3].value}</Typography>
                          <Typography sx={{ fontSize: "14px", textAlign: "center", marginLeft: "10px" }}>{testOnApp[3].description}</Typography>
                        </Box>
                      </Box>
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ display: "flex", alignItems: "center", width: "100%", paddingLeft: "10%", gap: "2px" }}>
                          <img src="https://ccicons.s3.amazonaws.com/analytics/tickMarksvg.svg" style={{ width: "30px", height: "30px" }} />
                          <Typography sx={{ fontSize: "22px", color: "#41B8D5" }}>{testOnApp[4].value}</Typography>
                          <Typography sx={{ fontSize: "14px", textAlign: "center", marginLeft: "10px" }}>{testOnApp[4].description}</Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", width: "100%", paddingLeft: "10%", gap: "2px" }}>
                          <img src="https://ccicons.s3.amazonaws.com/analytics/tickMarksvg.svg" style={{ width: "30px", height: "30px" }} />
                          <Typography sx={{ fontSize: "22px", color: "#41B8D5" }}>{testOnApp[5].value}</Typography>
                          <Typography sx={{ fontSize: "14px", textAlign: "center", marginLeft: "10px" }}>{testOnApp[5].description}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", gap: "1.5rem", width:"100%" }}>
            <Box borderRadius={5} sx={{ border: "1px solid rgba(255, 165, 0, 0.3)", padding: "1rem", display: "flex", flexDirection: "column", gap: "1rem", width: "50%" }}>
              <Typography variant="h4" sx={{}}>
              Active Days
              </Typography>
              {Object.keys(dayWisePromptness).length === 0 ? (
                <>
                  <Typography class="label-grey-text textTagsHere">No Data Available </Typography>
                </>
              ) : (
                <>
                  <Chart options={dayWisePromptenessOptions} series={dayWisePromptenessSeries} type="bar" width={"100%"} height={200} borderRadius={10} />
                  <Typography variant="h6" >The above-mentioned numbers show what percentage of students of this batch were active on each day of any week, preparing for their placements on the CareerCarve app. Activeness on our app is measured using student slot booking timings, time of booking slots, day & time of consuming podcasts & sessions, and time of the day when a student attempts assessment tests. </Typography>
                </>
              )}
            </Box>
            <Box borderRadius={5} sx={{ border: "1px solid rgba(255, 165, 0, 0.3)", padding: "1rem", display: "flex", flexDirection: "column", gap: "1rem", width: "50%" }}>
              <Typography variant="h4" sx={{}}>
                Active Time
              </Typography>
              {Object.keys(active_time).length === 0 ? (
                <>
                  <Typography class="label-grey-text textTagsHere">No Data Available </Typography>
                </>
              ) : (
                <>
                  <Box display="flex" justifyContent="space-evenly">
                    {/* {Object.entries(active_time).map(([key, value], index) => (
                      <Box marginTop="1rem" key={index}>
                        <img src={key === "12am-6am" ? "https://du03hetco8xdw.cloudfront.net/analytics/StudentActiveTime1.png" : key === "6am-12pm" ? "https://du03hetco8xdw.cloudfront.net/analytics/StudentActiveTime2.png" : key === "12pm-6pm" ? "https://du03hetco8xdw.cloudfront.net/analytics/StudentActiveTime3.png" : key === "6pm-12am" ? "https://du03hetco8xdw.cloudfront.net/analytics/StudentActiveTime4.png" : "https://du03hetco8xdw.cloudfront.net/analytics/StudentActiveTime5.png"} style={{ width: "100px", height: "100px", borderRadius: "100%" }} />
                        <Typography style={{ textAlign: "center", marginTop: "1rem" }}>{key}</Typography>
                        <Typography style={{ textAlign: "center", fontSize: "15px" }} className="student_details_info">
                          {"(" + DecimalToPercentage(value) + "% of batch" + ")"}
                        </Typography>
                      </Box>
                    ))} */}
                    {/* {Object.entries(active_time).map(([key, value], index) => {
                      const maxValue = Math.max(...Object.values(active_time));

                      const opacity = value === maxValue ? 1 : 0.3;

                      return (
                        <Box marginTop="1rem" key={index} style={{}}>
                          <img src={key === "12am-6am" ? "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime1.png" : key === "6am-12pm" ? "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime2.png" : key === "12pm-6pm" ? "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime3.png" : key === "6pm-12am" ? "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime4.png" : "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime5.png"} style={{ width: "100px", height: "100px", borderRadius: "100%", opacity: opacity }} />
                          <Typography style={{ textAlign: "center", marginTop: "1rem", color: value === maxValue ? "#E88F09" : "#000" }}>{key}</Typography>
                          <Typography style={{ textAlign: "center", fontSize: "15px" }} className="student_details_info">
                            {"(" + DecimalToPercentage(value) + "% of batch" + ")"}
                          </Typography>
                        </Box>
                      );
                    })} */}
                    {Object.entries(active_time).map(([key, value], index) => {
                      // Create an array of values
                      const values = Object.values(active_time);

                      // Sort the values in descending order
                      values.sort((a, b) => b - a);

                      // Find the index of the current value in the sorted array
                      const valueIndex = values.indexOf(value);

                      // Define opacity values based on the index
                      const opacityValues = [1, 0.6, 0.3, 0.15];

                      // Get the corresponding opacity based on the index
                      const opacity = opacityValues[valueIndex];

                      return (
                        <Box marginTop="1rem" key={index}>
                          <img src={key === "12am-6am" ? "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime1.png" : key === "6am-12pm" ? "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime2.png" : key === "12pm-6pm" ? "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime3.png" : key === "6pm-12am" ? "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime4.png" : "https://ccicons.s3.amazonaws.com/analytics/StudentActiveTime5.png"} style={{ width: "100px", height: "100px", borderRadius: "100%", opacity: opacity }} />
                          <Typography style={{ textAlign: "center", marginTop: "1rem", color: value === Math.max(...values) ? "#E88F09" : "#000" }}>{key}</Typography>
                          <Typography style={{ textAlign: "center", fontSize: "15px" }} className="student_details_info">
                            {"(" + DecimalToPercentage(value) + "% of batch" + ")"}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                  <Typography variant="h6" marginTop="2rem">
                  Time-slot highlighted above is the time when maximum number of students of this batch were active, preparing for their placements on the CareerCarve app. Activeness on our app is measured using student slot booking timings, time of booking slots, day & time of consuming podcasts & sessions, and time of the day when a student attempts assessment tests.
                  </Typography>
                </>
              )}
            </Box>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "space-between", gap: "1.5rem", width:"100%" }}>
            <Box borderRadius={5} sx={{ border: "1px solid rgba(255, 165, 0, 0.3)", padding: "1rem", display: "flex", flexDirection: "column", gap: "1rem", width: "50%" }}>
              <Typography variant="h4" sx={{}}>
                Student Engagement Quotient (SEQ)
              </Typography>
              {console.log("optionsComing", options)}
              {options.data.length > 0 && <AgChartsReact options={options} width={250} />}
              <Box sx={{ display: "flex", justifyContent: "space-between", width: "80%", marginTop: "0.5rem", alignItems: "center", gap: "1rem", margin: "0 auto" }}>
                <Typography variant="h5">Casual</Typography>
                <Line />
                <Typography variant="h5">Committed</Typography>
              </Box>
              <Typography variant="h6">According to the following facets: Tests taken, feedback viewed, feedback given, podcasts listened to, sessions watched, session recordings viewed - the engagement scores of all students are calculated and placed on a scale of casual to committed. Committed being most engaged and casual being least engaged with app content and sessions. </Typography>
            </Box>
            <Box borderRadius={5} sx={{ border: "1px solid rgba(255, 165, 0, 0.3)", padding: "1rem", display: "flex", flexDirection: "column", gap: "1rem", width: "50%" }}>
              <Typography variant="h4" sx={{}}>
                All about numbers: Aptitude Tests
              </Typography>
              {Object.keys(aptitude_test).length === 0 ? (
                <>
                  <Typography class="label-grey-text textTagsHere">No Data Available </Typography>
                </>
              ) : (
                <>
                  {aptitude_test?.["4"] === null && aptitude_test?.["3"] === null && aptitude_test?.["2"] === null ? (
                    <>
                      <Typography class="label-grey-text textTagsHere">No Data Available </Typography>
                    </>
                  ) : (
                    <>
                      {/* <Typography style={{ textAlign: "center" }}>Breakdown</Typography> */}

                      <Box display="flex" style={{ width: "100%", gap: "15px" }} alignItems={"center"}>
                        <ReactApexChart options={overAllAptitudeTestData.options} series={overAllAptitudeTestData.series} type="bar" height={110} width={400} />
                        {/* <Typography>{DecimalToPercentage(aptitude_test?.["4"] + aptitude_test?.["3"] + aptitude_test?.["2"]) / 3 + "/100"}</Typography> */}
                        <Typography sx={{ fontSize: "14px", color: "#41B8D5" }}>{aptitude_test?.["overall"]?.toFixed(4) * 100}/ 100 </Typography>
                      </Box>
                      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <Box display="flex" style={{ width: "100%", paddingInline: "5%", gap: "20px" }} alignItems={"center"}>
                          <ReactApexChart options={quantitativeData.options} series={quantitativeData.series} type="bar" height={180} width={350} />
                          <Box sx={{ display: "flex", flexDirection: "column", gap: "30px" }}>
                            <Typography sx={{ fontSize: "14px", color: "#41B8D5" }}>{aptitude_test?.["4"] !== null ? aptitude_test?.["4"]?.toFixed(4) * 100 : 0}/ 100 </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#41B8D5" }}>{aptitude_test?.["3"] !== null ? (aptitude_test?.["3"]?.toFixed(4) * 100)?.toFixed(2) : 0}/ 100 </Typography>
                            <Typography sx={{ fontSize: "14px", color: "#41B8D5" }}>{aptitude_test?.["2"] !== null ? aptitude_test?.["2"]?.toFixed(4) * 100 : 0}/ 100 </Typography>
                          </Box>
                        </Box>
                        {/* Displaying in only onr graph */}
                        {/* <Box display="flex" style={{ width: "100%", paddingInline: "5%", gap: "15px" }} alignItems={"center"}>
                          <ReactApexChart options={verbalData.options} series={verbalData.series} type="bar" height={100} width={400} />
                          <Typography>{DecimalToPercentage(aptitude_test?.["3"]).toFixed(2)} /100</Typography>
                        </Box>
                        <Box display="flex" style={{ width: "100%", paddingInline: "5%", gap: "15px" }} alignItems={"center"}>
                          <ReactApexChart options={logicalData.options} series={logicalData.series} type="bar" height={100} width={400} />
                          <Typography>{DecimalToPercentage(aptitude_test?.["2"]).toFixed(2)} /100</Typography>
                        </Box> */}
                      </Box>
                      <Typography variant="h6">Numbers mentioned above are the average scores of all students in this batch who have attempted at least 1 assessment test on the CareerCarve App. Overall score is a normalised average score of the entire batch in terms of all tests given till date.</Typography>
                    </>
                  )}
                </>
              )}
            </Box>
          </Box>
          <Box borderRadius={5} sx={{ display: "flex", flexDirection: "column", border: "1px solid rgba(255, 165, 0, 0.3)", padding: "1rem" }}>
            <Typography variant="h4" sx={{}}>
              Role Preparedness Tests: Specialization-wise
            </Typography>
            {Object.keys(tests_specialization_wise).length === 0 ? (
              <>
                <Typography class="label-grey-text textTagsHere">No Data Available </Typography>
              </>
            ) : (
              <>
                <Typography variant="h6" style={{ marginTop: ".5rem", color: "#525252", fontStyle: "italic" }}>
                  Roles displayed above are the top 10 roles in which the students of this batch performed best. Role preparedness batch-wise score is calculated using the scores of role preparedness tests on the CareerCarve app. Scores of all facets are normalised.
                </Typography>
                <Chart options={rolePreferenceOptions} series={rolePreferenceSeries} type="bar" width={"95%"} height={320} />
              </>
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default BatchProgressTracker;
